import axios from 'axios';
import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom';
import BACKEND_URL from '../../api';

export default function Subscription() {
  const url = window.location.href
  const plan = url.split("/").pop();
  const userid = sessionStorage.getItem('userid');

  React.useEffect(() => {
    axios({
      method: 'post',
      url: `${BACKEND_URL}/subscribePlan`,
      data: { userid: userid, plan: plan }
    })
      .then((res) => {
        console.log("subscribePlan----------:", res.data)
        window.location.replace(res.data._links.payment.href)
      }).catch((err) => console.log(err))
  }, [])

  return (
    <div>
      <p style={{ textAlign: "center" }}>You will be redirected to payment screen.</p>
    </div>
  )
}
